import React, { useEffect, useState } from 'react'
import { IndianRupee, CheckCircle, Clock, Download, Trash2 } from 'lucide-react'
import * as api from '../../../app/axios/api'
import { toast } from 'sonner'

import AuthorizedComponent from '../../../components/AuthorizedComponent'

export default function FeeHandoverSystem() {
  const [deleteConfirmId, setDeleteConfirmId] = useState(null)
  const [employees, setEmployees] = useState([])
  const [handovers, setHandovers] = useState([])
  const [loading, setLoading] = useState(true)

  console.log(handovers, 'handovers')

  const [formData, setFormData] = useState({
    total_collected: '',
    total_transactions: '',
    submitted_by: '', // Stores employee ID
    user_name: '', // Stores employee Name
    received_by_name: '',
    collection_date: '',
  })

  // const handleInputChange = (e) => {
  //   setFormData({
  //     ...formData,
  //     [e.target.name]: e.target.value,
  //   })
  // }

  // const handleSubmittedByChange = (e) => {
  //   const selectedId = e.target.value
  //   const selectedEmp = employees.find(
  //     (emp) => String(emp.id) === String(selectedId),
  //   )
  //   setFormData({
  //     ...formData,
  //     submitted_by: selectedId,
  //     user_name: selectedEmp ? selectedEmp.name : '',
  //   })
  // }

  const handleDelete = async (id) => {
    try {
      await api.deleteHandOverTakeOver(id)
      setHandovers(handovers.filter((h) => h.id !== id))
      setDeleteConfirmId(null)
      toast.success('Handover deleted successfully!')
    } catch (error) {
      console.error('Error deleting handover:', error)
      toast.error('Failed to delete handover. Please try again.')
    }
  }

  // const handleSubmit = async () => {
  //   if (
  //     !formData.total_collected ||
  //     !formData.submitted_by ||
  //     !formData.received_by_name ||
  //     !formData.collection_date
  //   ) {
  //     toast.error('Please fill all required fields')
  //     return
  //   }

  //   try {
  //     const handoverData = {
  //       submitted_by: parseInt(formData.submitted_by, 10),
  //       user_name: formData.user_name,
  //       collection_date: formData.collection_date,
  //       total_collected: parseFloat(formData.total_collected),
  //       total_transactions: parseInt(formData.total_transactions, 10) || 0,
  //       received_by_name: formData.received_by_name,
  //       approved: false,
  //     }

  //     await api.createHandOverTakeOver(handoverData)
  //     setFormData({
  //       total_collected: '',
  //       total_transactions: '',
  //       submitted_by: '',
  //       user_name: '',
  //       received_by_name: '',
  //       collection_date: '',
  //     })
  //     setShowForm(false)
  //     toast.success('Handover created successfully!')
  //     fetchHandOver()
  //   } catch (error) {
  //     console.error('Error creating handover:', error)
  //     toast.error('Failed to create handover. Please try again.')
  //   }
  // }

  const fetchEmployeelist = async () => {
    try {
      const res = await api.fetchEmployee()
      if (res.data && Array.isArray(res.data)) {
        setEmployees(res.data)
      } else {
        console.warn('API did not return an array for employees:', res.data)
        setEmployees([])
      }
    } catch (error) {
      console.error('Error fetching employee list:', error)
      setEmployees([])
    }
  }

  const fetchHandOver = async () => {
    try {
      setLoading(true)
      const res = await api.fetchHandOverTakeOver()

      if (res.data && Array.isArray(res.data)) {
        setHandovers(res.data)
      } else {
        console.warn('API did not return an array for handovers:', res.data)
        setHandovers([])
      }
    } catch (error) {
      console.error('Error fetching handover list:', error)
      setHandovers([])
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchEmployeelist()
    fetchHandOver()
  }, [])

  const handleApprove = async (id) => {
    try {
      await api.updateHandOverTakeOver(id, { approved: true })
      setHandovers(
        handovers.map((h) => (h.id === id ? { ...h, approved: true } : h)),
      )
      toast.success('Handover approved successfully!')
      fetchHandOver()
    } catch (error) {
      console.error('Error approving handover:', error)
      toast.error('Failed to approve handover. Please try again.')
    }
  }

  const formatDate = (dateString) => {
    if (
      !dateString ||
      dateString === '0001-01-01' ||
      dateString === '0001-01-01T00:00:00Z'
    )
      return 'N/A'
    try {
      const date = new Date(dateString)
      if (isNaN(date.getTime())) {
        return dateString
      }
      return date.toLocaleDateString('en-IN', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
      })
    } catch {
      return 'N/A'
    }
  }

  const downloadCSV = () => {
    const headers = [
      'Collection Date',
      'Submitted By',
      'Received By',
      'Total Collected (₹)',
      'Total Transactions',
      'Status',
    ]

    const rows = handovers.map((h) => [
      formatDate(h.collection_date),
      h.user_name || 'N/A',
      h.received_by_name || 'N/A',
      h.total_collected || 0,
      h.total_transactions || 0,
      h.approved ? 'Payment Success' : 'Pending Approval',
    ])

    let csvContent = headers.join(',') + '\n'
    rows.forEach((row) => {
      const escapedRow = row.map((cell) => {
        const cellStr = String(cell)
        if (
          cellStr.includes(',') ||
          cellStr.includes('"') ||
          cellStr.includes('\n')
        ) {
          return '"' + cellStr.replace(/"/g, '""') + '"'
        }
        return cellStr
      })
      csvContent += escapedRow.join(',') + '\n'
    })

    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' })
    const link = document.createElement('a')
    const url = URL.createObjectURL(blob)
    link.setAttribute('href', url)
    link.setAttribute(
      'download',
      `handover_records_${new Date().toISOString().split('T')[0]}.csv`,
    )
    link.style.visibility = 'hidden'
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  }

  const getStatusInfo = (handover) => {
    if (handover.approved) {
      return {
        label: 'Payment Success',
        className: 'bg-green-100 text-green-800',
      }
    } else {
      return {
        label: 'Pending Approval',
        className: 'bg-orange-100 text-orange-800',
      }
    }
  }

  return (
    <div className='min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 p-3 sm:p-4 md:p-6'>
      <div className='max-w-7xl mx-auto'>
        {/* Header */}
        <div className='bg-white rounded-lg shadow-lg p-3 sm:p-4 md:p-6 mb-4 md:mb-6'>
          <div className='flex flex-col sm:flex-row justify-between items-start sm:items-center gap-3 sm:gap-4'>
            <h1 className='text-xl sm:text-2xl md:text-3xl font-bold text-gray-800 flex items-center gap-2'>
              <IndianRupee className='text-green-600' size={24} />
              <span className='hidden sm:inline'>
                Daily Fee Collection Handover
              </span>
              <span className='sm:hidden'>Fee Handover</span>
            </h1>
            <div className='flex gap-2 flex-wrap w-full sm:w-auto'>
              <button
                onClick={downloadCSV}
                className='flex-1 sm:flex-initial px-3 sm:px-4 py-2 bg-gradient-to-r from-blue-600 to-indigo-600 text-white rounded-lg font-semibold text-sm hover:from-blue-700 hover:to-indigo-700 transition-all shadow-lg flex items-center justify-center gap-2'
              >
                <Download size={18} />
                Download CSV
              </button>
            </div>
          </div>
        </div>

        {/* Excel-style Table */}
        <div className='bg-white rounded-lg shadow-lg overflow-hidden'>
          <div className='overflow-x-auto'>
            <table className='w-full border-collapse'>
              <thead>
                <tr className='bg-gradient-to-r from-blue-600 to-indigo-600 text-white'>
                  <th className='px-3 py-3 text-left text-xs sm:text-sm font-semibold border border-gray-300'>
                    Collection Date
                  </th>
                  <th className='px-3 py-3 text-left text-xs sm:text-sm font-semibold border border-gray-300'>
                    Submitted By
                  </th>
                  <th className='px-3 py-3 text-left text-xs sm:text-sm font-semibold border border-gray-300'>
                    Received By
                  </th>
                  <th className='px-3 py-3 text-left text-xs sm:text-sm font-semibold border border-gray-300'>
                    Total Collected (₹)
                  </th>
                  <th className='px-3 py-3 text-left text-xs sm:text-sm font-semibold border border-gray-300'>
                    Total Transactions
                  </th>
                  <th className='px-3 py-3 text-left text-xs sm:text-sm font-semibold border border-gray-300'>
                    Status
                  </th>
                  <AuthorizedComponent requiredRole={['admin', 'manager']}>
                    <th className='px-3 py-3 text-left text-xs sm:text-sm font-semibold border border-gray-300'>
                      Action
                    </th>
                  </AuthorizedComponent>
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <tr>
                    <td
                      colSpan={7}
                      className='px-3 py-8 text-center text-gray-600 border border-gray-300'
                    >
                      Loading handovers...
                    </td>
                  </tr>
                ) : handovers.length === 0 ? (
                  <tr>
                    <td
                      colSpan={7}
                      className='px-3 py-8 text-center text-gray-600 border border-gray-300'
                    >
                      No handover records found
                    </td>
                  </tr>
                ) : (
                  handovers.map((handover, index) => {
                    const status = getStatusInfo(handover)
                    return (
                      <tr
                        key={handover.id || index}
                        className={index % 2 === 0 ? 'bg-gray-50' : 'bg-white'}
                      >
                        <td className='px-3 py-3 text-xs sm:text-sm text-gray-800 border border-gray-300 whitespace-nowrap'>
                          {formatDate(handover.collection_date)}
                        </td>
                        <td className='px-3 py-3 text-xs sm:text-sm text-gray-800 border border-gray-300'>
                          {handover.user_name || 'N/A'}
                        </td>
                        <td className='px-3 py-3 text-xs sm:text-sm text-gray-800 border border-gray-300'>
                          {handover.received_by_name || 'N/A'}
                        </td>
                        <td className='px-3 py-3 text-xs sm:text-sm font-semibold text-gray-800 border border-gray-300'>
                          ₹
                          {handover.total_collected
                            ? handover.total_collected.toLocaleString('en-IN')
                            : '0'}
                        </td>
                        <td className='px-3 py-3 text-xs sm:text-sm text-gray-800 border border-gray-300'>
                          {handover.total_transactions ?? '0'}
                        </td>
                        <td className='px-3 py-3 text-xs sm:text-sm border border-gray-300'>
                          <span
                            className={`px-2 py-1 rounded-full text-xs font-medium inline-flex items-center gap-1 ${status.className}`}
                          >
                            {handover.approved ? (
                              <CheckCircle size={14} />
                            ) : (
                              <Clock size={14} />
                            )}
                            {status.label}
                          </span>
                        </td>
                        <AuthorizedComponent
                          requiredRole={['admin', 'manager']}
                        >
                          <td className='px-3 py-3 text-xs sm:text-sm border border-gray-300'>
                            <div className='flex items-center gap-2'>
                              {!handover.approved ? (
                                <button
                                  onClick={() =>
                                    handleApprove(handover.handover_id)
                                  }
                                  className='px-3 py-1.5 bg-green-600 text-white rounded text-xs font-medium hover:bg-green-700 transition-colors flex items-center gap-1 whitespace-nowrap'
                                >
                                  <CheckCircle size={14} />
                                  Approve
                                </button>
                              ) : (
                                <span className='text-green-600 font-medium text-xs flex items-center gap-1'>
                                  <CheckCircle size={14} />
                                  Approved
                                </span>
                              )}
                              <button
                                onClick={() =>
                                  setDeleteConfirmId(handover.handover_id)
                                }
                                className='px-3 py-1.5 bg-red-600 text-white rounded text-xs font-medium hover:bg-red-700 transition-colors flex items-center gap-1 whitespace-nowrap'
                              >
                                <Trash2 size={14} />
                              </button>
                            </div>
                          </td>
                        </AuthorizedComponent>
                      </tr>
                    )
                  })
                )}
              </tbody>
            </table>
          </div>
        </div>

        {/* Delete Confirmation Modal */}
        {deleteConfirmId && (
          <div className='fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4'>
            <div className='bg-white rounded-lg shadow-2xl max-w-md w-full p-6'>
              <div className='flex items-center gap-3 mb-4'>
                <div className='p-3 bg-red-100 rounded-full'>
                  <Trash2 size={24} className='text-red-600' />
                </div>
                <h3 className='text-xl font-semibold text-gray-800'>
                  Confirm Delete
                </h3>
              </div>
              <p className='text-gray-600 mb-6'>
                Are you sure you want to delete this handover record? This
                action cannot be undone.
              </p>
              <div className='flex gap-3 justify-end'>
                <button
                  onClick={() => setDeleteConfirmId(null)}
                  className='px-4 py-2 border border-gray-300 text-gray-700 rounded-lg font-medium hover:bg-gray-50 transition-colors'
                >
                  Cancel
                </button>
                <button
                  onClick={() => handleDelete(deleteConfirmId)}
                  className='px-4 py-2 bg-red-600 text-white rounded-lg font-medium hover:bg-red-700 transition-colors flex items-center gap-2'
                >
                  <Trash2 size={16} />
                  Delete
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  )
}
